import {
  amplitudeKeyInternal,
  amplitudeKeyOldInternal,
  amplitudeKeyOldProd,
  amplitudeKeyProd,
  appTimestamp,
  appVersion,
  arcgisApiKeyDev,
  autodeskApiUrl,
  commitId,
  commitUrl,
  intercomAppIdDev,
  isNumberedEnv,
  jiraTicketId,
  jiraTicketUrl,
  localizeKey,
  muiProKey,
  numberedEnv,
  procoreApiUrlStaging,
  pullRequestId,
  pullRequestUrl,
  sentryDSNKey,
} from "@src/runtime-config-base";
import { RuntimeConfig } from "@src/runtime-config-types";

export const runtimeConfig: RuntimeConfig = {
  environment: "dev",
  appRegion: "eu",
  appEnv: "eu-dev",
  urls: {
    apiBaseUrl: "https://core.api.dev.holobuilder.eu",
    analyticsBaseUrl: "",
    sphereViewerUrl: "https://viewer.dev.holobuilder.eu",
    sphereVaultUrl: "https://vault.dev.holobuilder.eu",
    dashboard20Api: "https://sphere.dev.holobuilder.eu/api",
    hbWebEditorUrl: "https://app.dev.holobuilder.eu",
    progressApiUrl: "https://progress.api.dev.holobuilder.eu",
    sphereEntryPageUrl:
      numberedEnv === "dev1"
        ? "https://dev1.entry.dev.holobuilder.eu"
        : "https://entry.dev.holobuilder.eu",
    adminPanelUrl: "https://admin.dev.holobuilder.eu",
    cookieManagerUrl:
      "https://cookies.dev.holobuilder.eu/cookie-manager/manager/latest",
    powerBIBaseUrl: "https://hb-powerbi-func-eu-dev.azurewebsites.net",
    projectApiUrl: "https://v2.project.api.dev.holobuilder.eu",
    hbDashboardUrl: "https://dashboard.dev.holobuilder.eu",
    uploadFrontDoorUrl: "https://files.dev.holobuilder.eu",
    uploadStorageUrl: "https://holobuildereucorestorage.blob.core.windows.net",
    activityApiUrl: "https://activity.api.dev.holobuilder.eu",
  },
  features: {
    muiProKey,
    localizeKey,
    sentryDSNKey,
    auth0: {
      domain: "login.eu.dev.farosphere.com",
      clientId: "wSsYe8Ye5nQ0jfTxs0Urxrqy9evj6W2u",
    },
    amplitudeKeyInternal,
    amplitudeKeyProd,
    amplitudeKeyOldInternal,
    amplitudeKeyOldProd,
    intercomAppId: intercomAppIdDev,
    arcgisApiKey: arcgisApiKeyDev,
  },
  integrations: {
    procoreApiUrl: procoreApiUrlStaging,
    autodeskApiUrl,
  },
  appVersion,
  appTimestamp,
  commitId,
  commitUrl,
  pullRequestId,
  pullRequestUrl,
  jiraTicketId,
  jiraTicketUrl,
  mailSupportAddress: "support-eu+dev@holobuilder.com",
  isNumberedEnv,
  numberedEnv,
};
